import { useEffect } from "react";

const WhatsAppWidget = () => {
  useEffect(() => {
    const script = document.createElement("script");
    script.type = "text/javascript";
    script.async = true;
    script.src = "https://wati-integration-prod-service.clare.ai/v2/watiWidget.js?72550";

    script.onload = () => {
      const options = {
        enabled: true,
        chatButtonSetting: {
          backgroundColor: "#00e785",
          ctaText: "Chat with us",
          borderRadius: "25",
          marginLeft: "18",
          marginRight: "20",
          marginBottom: "20",
          ctaIconWATI: false,
          position: "left"
        },
        brandSetting: {
          brandName: "Journal of Applied Bioanalysis",
          brandSubTitle: "undefined",
          brandImg: "https://www.wati.io/wp-content/uploads/2023/04/Wati-logo.svg",
          welcomeText: "Hi there!\nHow can we help you?",
          messageText: "Hello, %0AI have a query regarding Article Publication",
          backgroundColor: "#00e785",
          ctaText: "Chat with us",
          borderRadius: "25",
          autoShow: false,
          phoneNumber: "971509279983"
        }
      };
      if (window.CreateWhatsappChatWidget) {
        window.CreateWhatsappChatWidget(options);
      }
    };

    document.body.appendChild(script);

    // Cleanup on unmount
    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return null; // No UI to render
};

export default WhatsAppWidget;
